import React, { useState } from 'react'
import gql from 'graphql-tag'
import { useTranslation } from 'react-i18next'

import {Form, Checkbox, Text } from 'components/forms'
import Button from 'components/Button'
import { useMutation } from 'components/graphql'
import Divider from 'components/Divider'

const pentacodePairMutation = gql`
	mutation pairCashRegisterPentacode($cashRegisterId: ID!, $pairingCode: String!) {
		cashAssist {
			pairCashRegisterPentacode(cashRegisterId: $cashRegisterId, pairingCode: $pairingCode) {
				id
				name
				parameters {
					pentacodeDeviceId
				}
			}
		}
	}
`
const pentacodeUnpairMutation = gql`
	mutation unpairCashRegisterPentacode($cashRegisterId: ID!) {
		cashAssist {
			unpairCashRegisterPentacode(cashRegisterId: $cashRegisterId) {
				id
				name
				parameters {
					pentacodeDeviceId
				}
			}
		}
	}
`
const TimeTracking = ({ formData, updateItem, appData, data }) => {
	const [t] = useTranslation()
	const [pairPentacode] = useMutation(pentacodePairMutation)
	const [unpairPentacode] = useMutation(pentacodeUnpairMutation)
	const isPentacodePaired = Boolean(data.parameters?.pentacodeDeviceId)
	const [pentacodePairCode, setPentacodePairCode] = useState('')

	const handlePentacodeUnpair = () => {
		unpairPentacode({
			variables: {
				cashRegisterId: data.id
			}
		})
	}
	const handlePentacodePair = () => {
		pairPentacode({
			variables: {
				cashRegisterId: data.id,
				pairingCode: pentacodePairCode
			}
		})
	}


	return (<>
		<Form
			smartSubmit
			initialValues={formData}
			onSubmit={updateItem}
		>
			<Checkbox field='parameters.isActiveTimeAssist' label={t('options_section.fields.activate_timeassist')} />
			<Checkbox field='parameters.loginOnlyAfterTimeRecording' label={t('options_section.fields.login_after_recording')} />
			<Checkbox field='parameters.logoutOnlyAfterTimeRecording' label={t('options_section.fields.logout_after_recording')} />
			<Checkbox field='parameters.isSellProductInWorkingTime' label={t('options_section.fields.register_products_logged_user')} />
		</Form>
		{appData.appConfigAdditional?.pentacodeEnabled && (<>
			<Divider/>
			{!isPentacodePaired &&
				<Text
					noForm
					value={pentacodePairCode}
					onChange={e => setPentacodePairCode(e.target.value)}
					label={`Pentacode ${t('options_section.strings.pairCode')}`}
					inline
				/>}
			{isPentacodePaired
				? <Button inline text={t('options_section.strings.unpair')} onClick={handlePentacodeUnpair} status='cancelation' />
				: <Button inline text={t('options_section.strings.pair')} onClick={handlePentacodePair} status='primary'/>
			}
		</>)}
	</>)
}

export default TimeTracking
